import { useEffect } from 'react';
import {
  resolveTravelDiaryTheme,
  toCssVariables,
  buildGoogleFontsUrl,
} from './branding';

export default function BrandingPreviewCard({
  values,
  title,
  subtitle,
  logoUrl,
}) {
  const theme = resolveTravelDiaryTheme(values);
  const cssVariables = toCssVariables(theme);
  const previewLogoUrl =
    values.avatar === null ? null : (values.avatar?.imageUrl ?? logoUrl);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = buildGoogleFontsUrl(theme);
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.displayFont, theme.bodyFont]);

  return (
    <div
      className="flex min-h-64 flex-col justify-center rounded-2xl p-10"
      style={{ ...cssVariables, background: 'var(--td-paper)' }}
    >
      <div className="flex items-center gap-3">
        {previewLogoUrl && (
          <span className="flex h-14 w-14 shrink-0 items-center overflow-hidden rounded-xl bg-white/90">
            <img
              src={previewLogoUrl}
              alt=""
              className="h-full w-full object-cover"
            />
          </span>
        )}
        <div
          className="text-2xl font-bold leading-snug"
          style={{
            fontFamily: 'var(--td-font-display)',
            color: 'var(--td-primary)',
          }}
        >
          {title}
        </div>
      </div>
      <div
        className="mt-1 text-sm"
        style={{ fontFamily: 'var(--td-font-body)', color: 'var(--td-ink)' }}
      >
        {subtitle}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span
          className="rounded-full px-3 py-1.5 text-xs font-semibold"
          style={{
            fontFamily: 'var(--td-font-body)',
            background: 'var(--td-primary)',
            color: 'var(--td-on-primary)',
          }}
        >
          Day 01
        </span>
        <span
          className="rounded-full border px-3 py-1.5 text-xs font-semibold"
          style={{
            fontFamily: 'var(--td-font-body)',
            borderColor: 'var(--td-ink)',
            color: 'var(--td-ink)',
          }}
        >
          Bangkok → Chiang Mai
        </span>
      </div>
    </div>
  );
}
